import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import Tour from '@core/components/Tour';
import { useApiUtils } from '@core/util/apiUtils';
import { steps } from '@core/util/tourUtils.js';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { Button, makeStyles } from '@material-ui/core';
import { usuarioApi } from 'app/services/api/usuarioApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { initializeReactGA } from 'app/utils/analyticsUtil';
import React, { useContext, useEffect, useState } from 'react';
import { FaShippingFast } from 'react-icons/fa';
import { useHistory } from 'react-router';
import TransportadoraBuscaAvancadaModal from './components/TransportadoraBuscaAvancadaModal/TransportadoraBuscaAvancadaModal';
import { TransportadoraCadastroModal } from './components/TransportadoraCadastroModal';
import { TransportadoraTable } from './components/TransportadoraTable';
import { TransportadoraVisualizacaoModal } from './components/TransportadoraVisualizacaoModal';
import { TransportadoraAction } from './store/transportadoraAction';
import { TransportadoraProvider, useTransportadora } from './store/transportadoraContext';

const useStyles = makeStyles({
  searchBarContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    maxWidth: '512px',
  },
  link: {
    color: '#53c4e6',
    fontWeight: '600',
    textTransform: 'initial',
  },
});

const SearchHeader = () => {
  const styles = useStyles();
  const [state, dispatch] = useTransportadora();

  const handleOpenBuscaAvancada = () => {
    dispatch(TransportadoraAction.buscaAvancada());
  };

  return (
    <PageHeader title="Transportadoras" icon={<FaShippingFast />}>
      <div className={`${styles.searchBarContainer}`}>
        <div className="flex items-center w-full max-w-512 stepBarraPesquisa">
          <SearchBar
            searchText={state.pesquisa}
            onChange={(value) => {
              dispatch(TransportadoraAction.setQuery(value));
            }}
          />
        </div>

        <div className="stepBuscaAvancada">
          <div className={styles.searchBarContainer}>
            <Button className={styles.link} onClick={handleOpenBuscaAvancada}>
              Busca avançada
            </Button>
          </div>
        </div>
      </div>
    </PageHeader>
  );
};

const TransportadoraContent = () => {
  const history = useHistory();
  const [state, dispatch] = useTransportadora();
  const apiUtils = useApiUtils(dispatch, Actions);

  const [run, setRun] = useState(false);
  const [tour, setTour] = useState(false);
  const [, setLoading] = useState(false);

  const [funcionalidadesTour, setFuncionalidadesTour] = useContext(GlobalContext).funcionalidadesTour;

  useEffect(() => {
    initializeReactGA(history?.location?.pathname);
    if (!funcionalidadesTour) {
      setFuncionalidadesTour([]);
    }
    onFetchData({
      page: state?.requestParams?.page,
      q: state?.requestParams?.q,
      size: state?.requestParams?.size,
      sort: state?.requestParams?.sort,
    });
    // Efeito de montagem: incluir as dependências reexecutaria a carga inicial a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFetchData = (params) => {
    const funcionalidadeJaExistente = funcionalidadesTour?.some((e) => e === 'TRANSPORTADORAS');
    if (!funcionalidadeJaExistente) {
      setRun(true);
      setTour(true);
      TransportadoraAction.buscarTour(dispatch);
    } else {
      TransportadoraAction.buscarRegistros(dispatch, params, state.filtroAvancado);
    }
  };

  const atualizarTour = async () => {
    try {
      setLoading(true);
      funcionalidadesTour.push('TRANSPORTADORAS');
      await usuarioApi.updateTour(funcionalidadesTour);
      setRun(false);
      setTour(false);
      setFuncionalidadesTour(funcionalidadesTour);
      onFetchData({
        page: state?.requestParams?.page,
        q: state?.requestParams?.q,
        size: state?.requestParams?.size,
        sort: state?.requestParams?.sort,
      });
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FusePageCarded
      innerScroll
      header={<SearchHeader />}
      content={
        <>
          <Tour steps={steps} run={run} setRun={setRun} onFinish={() => atualizarTour()} disableScrolling={true} />
          <TransportadoraTable onTour={tour} onFetchData={onFetchData} />
          <TransportadoraCadastroModal />
          <TransportadoraVisualizacaoModal />
          <TransportadoraBuscaAvancadaModal />
        </>
      }
    />
  );
};

const Transportadora = () => {
  return (
    <TransportadoraProvider>
      <TransportadoraContent />
    </TransportadoraProvider>
  );
};

export default Transportadora;
